import { render } from "./improvement.vue?vue&type=template&id=c9f1198c"
import script from "./improvement.vue?vue&type=script&lang=js"
export * from "./improvement.vue?vue&type=script&lang=js"

import "./improvement.vue?vue&type=style&index=0&id=c9f1198c&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__